{
  "status": {
    "draft": "Draft",
    "published": "Published",
    "archived": "Archived"
  },
  "attemptStatus": {
    "in_progress": "In progress",
    "submitted": "Awaiting grading",
    "graded": "Graded"
  },
  "questionType": {
    "single_choice": "Single choice",
    "multiple_choice": "Multiple choice",
    "short_text": "Short text",
    "open": "Open answer"
  },
  "list": {
    "title": "Tests",
    "description": "Tests you author, assign and grade.",
    "searchPlaceholder": "Search tests…",
    "statusFilter": "Status",
    "courseFilter": "Course",
    "anyStatus": "Any status",
    "anyCourse": "Any course",
    "questions": "{{count}} question",
    "questions_other": "{{count}} questions",
    "assignedTo": "Assigned to",
    "notAssigned": "Not assigned yet",
    "noTimeLimit": "No time limit",
    "timeLimit": "{{minutes}} min",
    "empty": {
      "title": "No tests yet",
      "text": "Create your first test, add questions, then assign it to a class.",
      "filterText": "Nothing matches the current filters."
    },
    "actions": {
      "edit": "Edit",
      "view": "View",
      "attempts": "Attempts",
      "publish": "Publish",
      "unpublish": "Unpublish",
      "duplicate": "Duplicate",
      "archive": "Archive",
      "more": "More actions for {{title}}"
    },
    "published": "Test published",
    "unpublished": "Test moved back to draft",
    "duplicated": "Test duplicated",
    "archived": "Test archived",
    "archiveTitle": "Archive {{title}}?",
    "archiveDescription": "The test disappears for pupils immediately. Attempts and grades already recorded stay.",
    "moduleFilter": "Module",
    "anyModule": "All modules",
    "kindFilter": "Work type",
    "anyKind": "All types"
  },
  "create": {
    "button": "Create test",
    "title": "Create a test",
    "description": "Name it now — settings and questions come next.",
    "titleLabel": "Test title",
    "titlePlaceholder": "e.g. Fractions — end of unit",
    "submit": "Create test",
    "success": "Test created",
    "failed": "Could not create the test"
  },
  "builder": {
    "title": "Test builder",
    "back": "Back to tests",
    "attempts": "Attempts",
    "settings": "Settings",
    "testTitle": "Test title",
    "descriptionLabel": "Description",
    "course": "Course",
    "noCourse": "No course",
    "lesson": "Lesson",
    "noLesson": "No lesson",
    "timeLimit": "Time limit (minutes)",
    "timeLimitHint": "Leave empty for no limit.",
    "maxAttempts": "Attempts allowed",
    "shuffleQuestions": "Shuffle questions",
    "shuffleAnswers": "Shuffle answer choices",
    "showCorrectAnswers": "Show correct answers after grading",
    "availableFrom": "Available from",
    "availableUntil": "Available until",
    "save": "Save settings",
    "saved": "Settings saved",
    "saveFailed": "Could not save the settings",
    "publish": "Publish",
    "unpublish": "Unpublish",
    "duplicate": "Duplicate",
    "archive": "Archive",
    "assign": "Assign to class",
    "frozen": "This test already has attempts, so its questions are locked. Duplicate the test to change them.",
    "questions": {
      "title": "Questions",
      "empty": "No questions yet — add the first one below.",
      "add": "Add question",
      "position": "Question {{index}}",
      "text": "Question text",
      "points": "Points",
      "moveUp": "Move question up",
      "moveDown": "Move question down",
      "delete": "Delete question",
      "deleteTitle": "Delete this question?",
      "deleteDescription": "The question and its answer key are removed from the test.",
      "save": "Save question",
      "saved": "Question saved",
      "added": "Question added",
      "deleted": "Question deleted"
    },
    "choices": {
      "label": "Choices",
      "add": "Add choice",
      "remove": "Remove choice {{index}}",
      "text": "Choice {{index}}",
      "correctSingle": "Mark choice {{index}} as the correct answer",
      "correctMultiple": "Choice {{index}} is correct",
      "correct": "Correct",
      "hintSingle": "Exactly one choice must be correct.",
      "hintMultiple": "Mark every correct choice — pupils must select them all to score."
    },
    "accepted": {
      "label": "Accepted answers",
      "add": "Add accepted answer",
      "placeholder": "Type an accepted answer and press Enter",
      "remove": "Remove accepted answer {{value}}",
      "hint": "Matching ignores case and extra spaces."
    },
    "open": {
      "hint": "Open answers are graded by hand from the attempts queue."
    },
    "readOnly": {
      "title": "You can read this test, but not edit it",
      "text": "It belongs to another teacher. Only a school admin, the test's author, or a teacher of a class it is assigned to can change it — duplicate it to get a copy that is yours.",
      "duplicate": "Duplicate to edit"
    },
    "kind": "Work type"
  },
  "assign": {
    "title": "Assign to a class",
    "description": "Pupils in the class see the test once it is published and inside its availability window.",
    "classLabel": "Class",
    "classPlaceholder": "Choose a class",
    "dueAt": "Due (optional)",
    "submit": "Assign",
    "success": "Test assigned",
    "current": "Currently assigned",
    "none": "Not assigned to any class yet.",
    "noClasses": "No active classes to assign to — create a class first.",
    "due": "Due {{date}}",
    "noDue": "No due date",
    "unassign": "Unassign {{name}}",
    "unassignTitle": "Unassign {{name}}?",
    "unassignDescription": "The test disappears from that class immediately. Attempts already made stay recorded.",
    "unassigned": "Class unassigned",
    "validation": "Choose a class",
    "unassignConfirm": "Unassign"
  },
  "attempts": {
    "title": "Attempts",
    "description": "Every pupil's run through {{title}}.",
    "back": "Back to the test",
    "pupil": "Pupil",
    "attemptNumber": "Attempt {{number}}",
    "status": "Status",
    "score": "Score",
    "submitted": "Submitted",
    "needsGradingOnly": "Needs grading only",
    "empty": "No attempts yet.",
    "open": "Grade",
    "notSubmitted": "—"
  },
  "grading": {
    "title": "Grading attempt {{number}}",
    "back": "Back to attempts",
    "pupilAnswer": "Pupil's answer",
    "noAnswer": "No answer given",
    "autoGraded": "Auto-graded",
    "earned": "{{points}} / {{max}}",
    "pointsLabel": "Points (max {{max}})",
    "feedbackLabel": "Feedback (optional)",
    "submit": "Save grades",
    "saved": "Grades saved",
    "failed": "Could not save the grades",
    "inProgress": "This attempt is still in progress — it cannot be graded yet.",
    "noOpenQuestions": "This test has no open questions; it was graded automatically.",
    "total": "Total: {{score}} / {{max}}"
  },
  "pupilList": {
    "title": "Tests",
    "description": "Tests your teachers have shared with you.",
    "empty": {
      "title": "No tests right now",
      "text": "Tests your teachers open for your classes appear here, along with your results once they are graded."
    },
    "window": "Open until {{date}}",
    "opens": "Opens {{date}}",
    "attemptsLeft": "{{count}} attempt left",
    "attemptsLeft_other": "{{count}} attempts left",
    "noAttemptsLeft": "No attempts left",
    "noAttemptsLeftHint": "You have used all attempts for this test. Ask your teacher if you need another one.",
    "bestScore": "Best score: {{score}} / {{max}}",
    "lastAttempt": "Last attempt: {{status}}",
    "start": "Start",
    "resume": "Resume",
    "startTitle": "Start {{title}}?",
    "startDescriptionSingle": "You get one attempt only. Once you start, it counts.",
    "startDescriptionTimed": "The timer starts as soon as you begin: {{minutes}} minutes.",
    "startFailed": "Could not start the test",
    "questionsCount": "{{count}} question",
    "questionsCount_other": "{{count}} questions",
    "totalPoints": "Points: {{points}}",
    "yourResult": "Your result",
    "awaitingGrading": "Awaiting grading — the result will appear once the teacher marks it"
  },
  "take": {
    "back": "Back to tests",
    "question": "Question {{index}} of {{total}}",
    "points": "Points: {{points}}",
    "shortTextPlaceholder": "Your answer",
    "openPlaceholder": "Write your answer",
    "answerLabel": "Your answer",
    "saving": "Saving…",
    "saved": "All answers saved",
    "saveFailed": "Could not save — retrying",
    "retry": "Retry now",
    "timeLeft": "Time left {{time}}",
    "timeAlmostUp": "Less than a minute left",
    "timeUp": "Time is up — your answers were submitted.",
    "submit": "Submit test",
    "submitTitle": "Submit your answers?",
    "submitDescription": "You cannot change your answers after submitting.",
    "unanswered": "{{count}} question is still unanswered.",
    "unanswered_other": "{{count}} questions are still unanswered.",
    "submitFailed": "Could not submit the test",
    "alreadySubmitted": "This attempt has already been submitted."
  },
  "result": {
    "title": "Your result",
    "awaitingGrading": "Submitted. Your teacher still has to grade the open questions.",
    "score": "{{score}} / {{max}}",
    "scoreLabel": "Score",
    "gradeLabel": "Grade",
    "perQuestion": "Per question",
    "earned": "{{points}} / {{max}} points",
    "correct": "Correct",
    "incorrect": "Incorrect",
    "correctAnswer": "Correct answer",
    "correctAnswers": "Correct answers",
    "acceptedAnswers": "Accepted answers",
    "feedback": "Teacher feedback",
    "yourAnswer": "Your answer",
    "backToTests": "Back to tests"
  },
  "validation": {
    "titleRequired": "Title is required",
    "pointsRange": "Points must be a positive number"
  },
  "linkedSection": {
    "lessonTitle": "Tests for this lesson",
    "courseTitle": "Tests for this course",
    "create": "Create test",
    "empty": "No tests are linked here yet.",
    "questions_other": "{{count}} questions",
    "questions_one": "{{count}} question"
  },
  "kinds": {
    "current": "Classwork",
    "independent": "Independent work",
    "control": "Summative test",
    "thematic": "Thematic assessment",
    "diagnostic": "Diagnostic"
  }
}
